import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import BreadCrumb from "@/components/BreadCrumb.vue";
import { useRouter } from "vue-router";
// import { ElAside } from 'element-plus'
export default {
  components: {
    BreadCrumb
    // ElAside
  },
  setup() {
    var _routers$find$childre;
    const menus = [{
      path: "/helping-center/help-manual",
      meta: {
        title: "帮助手册",
        icon: require("@/assets/img/setting/position.png"),
        desc: "帮助手册学习及下载"
      }
    }];
    const routers = useRouter().options.routes;
    console.log(routers);
    const settingMenus = (_routers$find$childre = routers.find(i => i.name === "main").children.find(j => j.name === "helping-center").children) !== null && _routers$find$childre !== void 0 ? _routers$find$childre : menus;
    return {
      settingMenus
    };
  }
};